import type { ConversationNodeAnnouncement } from 'lib-shared-types-api';

type Props = {
  node: ConversationNodeAnnouncement;
};

export function RoutedThroughAnnouncement({ node }: Props): JSX.Element {
  return (
    <>
      Audio message · <strong>{node.label}</strong> is played
    </>
  );
}
